interface StatItem {
  value: string;
  label: string;
}

interface TrustSectionProps {
  title: string;
  subtitle: string;
  stats: StatItem[];
}

export default function TrustSection({ title, subtitle, stats }: TrustSectionProps) {
  return (
    <section className="w-full py-16 md:py-20 bg-background-900">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
            {title}
          </h2>
          <p className="text-sm text-foreground-400">
            {subtitle}
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center p-6 rounded-2xl border border-foreground-800 bg-background-800/50"
            >
              <div className="text-3xl md:text-4xl font-heading font-bold text-primary-400 mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-400">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}